import { HPoolManagerContract } from './contractsRegistryService';
import { useContractReader, getContractAddress, newContractReader } from './contractReader';
import { approveAddressOnAsset, assetAmountInWei, getAssetsContract, safeAmountInWei } from './assetsService';
import { HORD_SYMBOL } from '../constants/general';
import configJson from '../config/config.json';
import { getChampionToken } from './championService';
import { handleResponse } from './apiService';
import { signTypedDataV4 } from './web3Service';
import { divideOnWei, getValueByMultiProps, multiConver, objectMapper, reArrangeObj } from '../utils/mapper';
import { getMinAmountToStake } from './createHPoolService';

const ethAddress = '0xc778417e063141139fce010982780140aa0cd5ab';

export const hpoolPublicSubscribe = async (hpoolWeb3Id = 0, value) => {
  const contract = await HPoolManagerContract();
  return useContractReader(contract, 'publicSubscribeForHPool', [hpoolWeb3Id, { value }]);
};

export const getSpendingAllownce = async (wallet) => {
  const hordTicketManagerAddress = await getContractAddress('HordTicketManager');
  return useContractReader('HordToken', 'allowance', [wallet, hordTicketManagerAddress]);
};

export const getNumberOfTokensUserCanClaimRequest = async (walletAddress, contractAddress) => {
  const numOfTokens = await useContractReader(
    'Hpool',
    'getNumberOfTokensUserCanClaim',
    [walletAddress],
    undefined,
    contractAddress,
  );
  return numOfTokens;
};

export const getAssetsAndBalances = async (contractAddress) => {
  const assetsAndBalances = await useContractReader(
    'Hpool',
    'getAssetsAndBalances',
    [0, 0],
    undefined,
    contractAddress,
  );
  return assetsAndBalances;
};

export const redeemUserTokens = async (
  hpoolAddress,
  account,
  {
    amountHPoolTokensFromWallet: _amountHPoolTokensFromWallet = 0,
    amountHPoolTokensUnclaimed: _amountHPoolTokensUnclaimed = 0,
  },
) => {
  const amountHPoolTokensFromWallet = safeAmountInWei(_amountHPoolTokensFromWallet || 0);
  const amountHPoolTokensUnclaimed = safeAmountInWei(_amountHPoolTokensUnclaimed || 0);

  return new Promise((resolve, reject) => {
    useContractReader(
      'HPool',
      undefined,
      undefined,
      async (contractInstance) => {
        try {
          contractInstance.methods
            .liquidatePositionAndPullAssets(amountHPoolTokensFromWallet, amountHPoolTokensUnclaimed)
            .send({ from: account })
            .once('transactionHash', () => {})
            .once('receipt', (receipt) => {
              resolve(receipt);
            })
            .on('error', (err) => {
              reject(err);
            });
        } catch (error) {
          reject(error);
        }
      },
      hpoolAddress,
    );
  });
};
export const getUserStaketsRequest = async (account, nftWeb3Id) => {
  const value = useContractReader('HordTicketManager', 'getUserStakesForTokenId', [account, nftWeb3Id]);
  return value;
};

export const hpoolPrivateSubscribe = async (hpoolWeb3Id = 0, value) => {
  const contract = await HPoolManagerContract();
  return useContractReader(contract, 'privateSubscribeForHPool', [hpoolWeb3Id, { value }]);
};

export const getHpoolTotalAssetsAmount = async (hpoolAddress) => {
  if (!hpoolAddress) return 0;
  try {
    const HpoolContract = await getAssetsContract(hpoolAddress);
    const amount = await HpoolContract.methods.assetsRatio(hpoolAddress).call();
    return amount;
  } catch (error) {
    console.log({ error });
  }
};

export const getChampionTokensAndShareAmount = async (contractAddress) => {
  const champStats = await useContractReader(
    'Hpool',
    'getNumberOfChampionTokens',
    undefined,
    undefined,
    contractAddress,
  );

  return champStats;
};

export const getNumberOfSubscribers = async (hpoolWeb3Id = 0, chainId) => {
  const numberOfSubscriptions = await newContractReader({
    contractName: 'HordHpoolManager',
    functionName: 'numberOfSubscriptions',
    params: [hpoolWeb3Id],
    chainId,
  });
  return numberOfSubscriptions;
};

export const isSubscribedReq = async (poolId, account) =>
  useContractReader('HordHpoolManager', 'getUserSubscriptionForPool', [poolId, account]);

export const getUsertInfoReq = (contractAddress, account) =>
  useContractReader('Hpool', 'getUserInfo', [account], undefined, contractAddress);

export const getContributionInfoReq = (poolId, account, contractAddress) =>
  new Promise(async (res, rej) => {
    try {
      const subscriptionInfo = await isSubscribedReq(poolId, account);
      const myTokensInfo = await getUsertInfoReq(contractAddress, account);
      return res({ subscriptionInfo, myTokensInfo });
    } catch (error) {
      rej(error);
    }
  });

// export const getStakingDuration = () => useContractReader('HordTicketManager', 'minTimeToStake');
export const getStakingDuration = () => useContractReader('HordConfiguration', 'minTimeToStake');

export const approveHordSpend = async (account, numberOfTickets) => {
  const hordTicketManagerAddress = await getContractAddress('HordTicketManager');
  const minAmountToStake = await getMinAmountToStake();
  const hordAmount = numberOfTickets * minAmountToStake;
  return approveAddressOnAsset(account, hordTicketManagerAddress, hordAmount);
};

export const claimTicketsAndStack = (nftId, numberOfTickets, poolWeb3Id, account) =>
  newContractReader({
    contractName: 'HordTicketManager',
    functionName: 'stakeAndReserveNFTs',
    params: [nftId, numberOfTickets, poolWeb3Id],
    sendParams: { from: account },
  });

// new Promise((resolve, reject) => {
//   useContractReader('HordTicketManager', 'stakeAndReserveNFTs', null, (contractInstance) => {
//     contractInstance.methods
//       .stakeAndReserveNFTs(nftId, numberOfTickets, poolWeb3Id)
//       .send({ from: account })
//       .once('transactionHash', () => {})
//       .once('receipt', (receipt) => {
//         console.log('depositHPool_receipt', receipt);
//         const { transactionHash } = receipt || {};
//         resolve(transactionHash);
//       })
//       .on('error', (err) => {
//         reject(err);
//       });
//   });
// });

export const createTradeOrder = (body) => {
  const config = {
    method: 'POST',
    headers: { Authorization: `Bearer ${getChampionToken()}` },
    body: JSON.stringify(body),
  };
  return fetch(`${configJson.apiPath}/trade_order `, config).then(handleResponse);
};
export const updatePoolStatsReq = (hpoolContractAddress) => {
  const config = {
    method: 'POST',
    headers: { Authorization: `Bearer ${getChampionToken()}` },
  };
  return fetch(`${configJson.apiPath}/hpool/stats/${hpoolContractAddress}`, config).then(handleResponse);
};

export const getHpoolStats = (hpoolContractAddress) => {
  const config = {
    method: 'GET',
    headers: { Authorization: `Bearer ${getChampionToken()}` },
  };
  return fetch(`${configJson.apiPath}/hpool/stats/${hpoolContractAddress}`, config).then(handleResponse);
};

export const updateTradeOrder = (id, body) => {
  const config = {
    method: 'PUT',
    headers: { Authorization: `Bearer ${getChampionToken()}` },
    body: JSON.stringify(body),
  };
  return fetch(`${configJson.apiPath}/trade_order/${id}`, config).then(handleResponse);
};

export const deleteTradeOrderReq = (tradeOrderId) => {
  const url = `${configJson.apiPath}/trade_order/${tradeOrderId}`;
  const body = { delete: true };
  const config = {
    method: 'PUT',
    headers: { Authorization: `Bearer ${getChampionToken()}` },
    body: JSON.stringify(body),
  };
  return fetch(url, config).then(handleResponse);
};

export const hordToEth = ({ value, hordToUsd, usdToEth }) => {
  if (!hordToUsd) return assetAmountInWei(value);
  const hordInUsd = hordToUsd(value);
  const usdInEth = usdToEth(hordInUsd);
  return usdInEth;
};

const handleAmountValues = ({ value, hordToUsd, usdToEth }) => {
  const usdInEth = hordToEth({ value, hordToUsd, usdToEth });
  const valueInWei = assetAmountInWei(usdInEth);
  return valueInWei;
};

const conveterMapSchema = () => [
  {
    keys: ['priceUSD', 'amountUSD', 'amountSrc'],
    convert: (value) => assetAmountInWei(value),
  },
  {
    keys: ['validUntil'],
    convert: (date) => new Date(date).getTime() / 1000,
  },
];

export const typesMapper = {
  // for initial order
  BuyOrderRatio: [
    { name: 'dstToken', type: 'address' },
    { name: 'ratio', type: 'uint256' },
    { name: 'poolNonce', type: 'uint256' },
    { name: 'poolId', type: 'uint256' },
  ],
  // for reblancing
  TradeOrder: [
    { name: 'srcToken', type: 'address' },
    { name: 'dstToken', type: 'address' },
    { name: 'amountSrc', type: 'uint256' },
    { name: 'poolNonce', type: 'uint256' },
    { name: 'poolId', type: 'uint256' },
  ],
  // those four is for future orders
  SellLimit: [
    { name: 'srcToken', type: 'address' },
    { name: 'dstToken', type: 'address' },
    { name: 'priceUSD', type: 'uint256' },
    { name: 'amountSrc', type: 'uint256' },
    { name: 'validUntil', type: 'uint256' },
    { name: 'poolNonce', type: 'uint256' },
    { name: 'poolId', type: 'uint256' },
  ],
  BuyLimit: [
    { name: 'srcToken', type: 'address' },
    { name: 'dstToken', type: 'address' },
    { name: 'priceUSD', type: 'uint256' },
    { name: 'amountUSD', type: 'uint256' },
    { name: 'validUntil', type: 'uint256' },
    { name: 'poolNonce', type: 'uint256' },
    { name: 'poolId', type: 'uint256' },
  ],
  StopLoss: [
    { name: 'srcToken', type: 'address' },
    { name: 'dstToken', type: 'address' },
    { name: 'priceUSD', type: 'uint256' },
    { name: 'amountSrc', type: 'uint256' },
    { name: 'validUntil', type: 'uint256' },
    { name: 'poolNonce', type: 'uint256' },
    { name: 'poolId', type: 'uint256' },
  ],
  EndPool: [
    { name: 'poolId', type: 'uint256' },
    { name: 'poolNonce', type: 'uint256' },
  ],
  Whitelist: [
    { name: 'poolId', type: 'uint256' },
    { name: 'userAddress', type: 'address' },
  ],
};

export const getSignatureConfig = (signatureType, src = typesMapper) => {
  const typeParams = src?.[signatureType];
  const type = {
    [signatureType]: [...typeParams],
  };
  const primaryType = {
    primaryType: signatureType,
  };
  return {
    type,
    primaryType,
  };
};

export const futureOrderTypeSchema = {
  buy_limit: 'BuyLimit',
  sell_limit: 'SellLimit',
  stop_loss: 'StopLoss',
  amount_source: 'amountSrc',
  amount_usd: 'amountUSD',
  price_usd: 'priceUSD',
  valid_until: 'validUntil',
  end_hpool: 'EndPool',
};

export const orderResponseSchema = {
  amount_usd_wei: 'amountUSD',
  price_usd_wei: 'priceUSD',
  token_address: 'dstToken',
  base_token_address: 'srcToken',
  valid_until_timestamp: 'validUntil',
  id: 'poolNonce',
  hpool_id: 'poolId',
  token_amount_wei: 'amountSrc',
};

export const tradeOrderSchema = {
  MARKET_SELL: 'MarketSell',
  MARKET_BUY: 'MarketBuy',
};

export const getMappedFutureOrderType = (obj, schema = futureOrderTypeSchema) => objectMapper(obj, schema);
export const getMappedFutureKeyType = (key) => futureOrderTypeSchema?.[key];

// date should be convertoed to seconds
export const defaultSignedType = 'BuyOrderRatio';

export const orderTypesMapper = {
  MARKET_SELL: 'Sell',
  MARKET_BUY: 'Buy',
};

export const removeUnusedObjKeys = (baseObj, rawKeys = []) => {
  let obj = {};
  const keys = rawKeys.map((key) => key.name);
  keys.forEach((key) => {
    obj = { ...obj, [key]: baseObj?.[key] };
  });
  return obj;
};

export const mapOrderType = (type) => orderTypesMapper?.[type];

const hordIsDstCases = ['BuyLimit', 'BuyOrderRatio'];

const getSrcAndDst = ({ baseToken, forToken, signatureType, defaultDstToken }) => {
  const hordAddress = defaultDstToken;

  let srcToken = hordAddress;
  let dstToken = hordAddress;

  if (signatureType) {
    srcToken = hordIsDstCases.includes(signatureType) ? ethAddress : hordAddress;
    dstToken = hordIsDstCases.includes(signatureType) ? hordAddress : ethAddress;
  }
  if (baseToken) {
    srcToken = baseToken.token_address;
    dstToken = forToken.token_address;
  }
  return { srcToken, dstToken };
};

const constructMsg = ({
  baseToken,
  forToken,
  poolNonce,
  poolId,
  ratio,
  diff: diffAmountSrc,
  typeParams,
  futureOrderPayload,
  defaultDstToken,
  signatureType,
}) => {
  const { srcToken, dstToken } = getSrcAndDst({ baseToken, forToken, defaultDstToken, signatureType });
  const mappedFuturePayload = getMappedFutureOrderType({
    ...futureOrderPayload,
  });

  const rawAmountSrc = diffAmountSrc || futureOrderPayload.amount_source;
  const amountSrc = assetAmountInWei(rawAmountSrc);

  const rawMessage = {
    srcToken,
    dstToken,
    poolId,
    ratio,
    poolNonce,
    amountSrc,
    ...mappedFuturePayload,
  };
  const message = removeUnusedObjKeys(rawMessage, typeParams);
  const messageAfterProcessing = multiConver(conveterMapSchema?.() || [], message);
  const afterMerge = removeUnusedObjKeys({ ...message, ...messageAfterProcessing }, typeParams);
  const reArrangedObj = reArrangeObj(afterMerge, typeParams);
  return reArrangedObj;
};

const parsedMapSchema = [
  {
    keys: ['priceUSD', 'amountUSD', 'amountSrc'],
    convert: (value = 0) => BigInt(value).toString(),
  },
];

export const parseResponseSignature = async ({ trade_order: tradeOrder } = {}) => {
  const orderType = tradeOrder?.order_type?.toLowerCase();
  const mappedOrderType = futureOrderTypeSchema?.[orderType];
  const responseParsedSignature = getMappedFutureOrderType(tradeOrder, orderResponseSchema);
  const typeParams = typesMapper?.[mappedOrderType];

  let message = removeUnusedObjKeys(responseParsedSignature, typeParams);
  let { srcToken, dstToken } = message;

  const primaryType = {
    primaryType: mappedOrderType,
  };

  const type = {
    [mappedOrderType]: [...typeParams],
  };

  if (!hordIsDstCases.includes(mappedOrderType)) {
    const temp = srcToken;
    srcToken = dstToken;
    dstToken = temp;
  }

  message = { ...message, srcToken, dstToken };
  const messageAfterProcessing = multiConver(parsedMapSchema, message);
  const afterCleaninng = removeUnusedObjKeys(messageAfterProcessing, typeParams);
  const signature = await signTypedDataV4(afterCleaninng, type, primaryType);
  return signature;
};

const swapTokensBaseOnType = (base, dst, isSell) => {
  if (isSell) return [dst, base];
  return [base, dst];
};

export const handleModifiedOrders = async (tradeOrder, signatureType) => {
  const { id: poolNonce, hpool_id: poolId } = tradeOrder;
  const {
    base_token_address: _srcToken,
    token_address: _dstToken,
    order_type: orderType,
    token_ratio: tokenRatio,
    base_token_purchase_amount_at_creation_wei: marketBuyAmountSrc,
    token_amount_at_creation_wei: marketSellAmountSrc,
  } = tradeOrder;
  const isSell = orderType?.toLowerCase().includes('sell');
  const [srcToken, dstToken] = swapTokensBaseOnType(_srcToken, _dstToken, isSell);
  const amountSrc = isSell ? marketSellAmountSrc : marketBuyAmountSrc;

  const ratio = assetAmountInWei(tokenRatio);
  const typeParams = typesMapper?.[signatureType];
  const type = {
    [signatureType]: [...typeParams],
  };
  const primaryType = {
    primaryType: signatureType,
  };
  const message = {
    srcToken,
    dstToken,
    poolNonce,
    amountSrc,
    poolId,
  };
  const signature = await signTypedDataV4(message, type, primaryType);
  const assetSignatureBody = {
    signature,
    ratio,
    type: orderType,
    trade_order_id: poolNonce,
  };
  return assetSignatureBody;
};

// reblancing requires you to send new order type which would be MARKET_BUY or MARKET_SELL
export const getAssetSignatureRequest = async (
  tradeOrder = {},
  signatureType = 'BuyOrderRatio',
  orderType = 'INITIAL_MARKET_BUY',
  futureOrderPayload = {},
  coinConvertToolkit,
) => {
  const { id: poolNonce, token_address: dstToken, hpool_id: poolId, baseToken, forToken, diff, amountSrc } = tradeOrder;
  const tokenRatio = getValueByMultiProps(tradeOrder, ['percentage', 'token_ratio', 'current_ratio_from_pool']);
  const ratio = assetAmountInWei(tokenRatio);

  const typeParams = typesMapper?.[signatureType];
  const type = {
    [signatureType]: [...typeParams],
  };

  const _message = constructMsg({
    baseToken,
    forToken,
    poolNonce,
    poolId,
    typeParams,
    diff,
    amountSrc,
    futureOrderPayload,
    defaultDstToken: dstToken,
    ratio,
    signatureType,
    coinConvertToolkit,
  });

  const primaryType = {
    primaryType: signatureType,
  };
  const signature = await signTypedDataV4(_message, type, primaryType);
  const assetSignatureBody = {
    signature,
    ratio,
    type: orderType,
    trade_order_id: tradeOrder.id,
  };
  return assetSignatureBody;
};

export const getOpenOrdersReq = async (hpoolId) => {
  if (!hpoolId) throw new Error('Hpool Id is required');
  const config = {
    method: 'GET',
    headers: { Authorization: `Bearer ${getChampionToken()}` },
  };
  return fetch(`${configJson.apiPath}/trade_order?hpool_id=${hpoolId}`, config).then(handleResponse);
};

export const endPoolReq = (poolId) => {
  const body = {
    hpool_id: poolId,
  };
  const config = {
    method: 'POST',
    headers: { Authorization: `Bearer ${getChampionToken()}` },
    body: JSON.stringify(body),
  };
  return fetch(`${configJson.apiPath}/end_hpool`, config).then(handleResponse);
};

export const updateEndPoolReq = async (tradeOrderId, body) => {
  const config = {
    method: 'PUT',
    headers: { Authorization: `Bearer ${getChampionToken()}` },
    body: JSON.stringify(body),
  };
  return fetch(`${configJson.apiPath}/end_hpool/${tradeOrderId}`, config).then(handleResponse);
};

export const redeemEndedPool = async (
  contractAddress,
  account,
  _amountHPoolTokensFromWallet,
  _amountHPoolTokensUnclaimed,
) => {
  const amountHPoolTokensFromWallet = safeAmountInWei(_amountHPoolTokensFromWallet || 0);
  const amountHPoolTokensUnclaimed = safeAmountInWei(_amountHPoolTokensUnclaimed || 0);
  return new Promise((resolve, reject) => {
    useContractReader(
      'HPool',
      undefined,
      undefined,
      (contractInstance) => {
        contractInstance.methods
          .redeemAssetsOnPoolEnd(amountHPoolTokensFromWallet, amountHPoolTokensUnclaimed)
          .send({ from: account })
          .once('transactionHash', () => {})
          .once('receipt', (receipt) => {
            resolve(receipt);
          })
          .on('error', (err) => {
            reject(err);
          });
      },
      contractAddress,
    );
  });
};

export const claimNftsReq = (account, web3Id, startIndex = 0, endIndex = 1) =>
  new Promise((res, rej) => {
    useContractReader('HordTicketManager', undefined, undefined, (contractInstance) => {
      contractInstance.methods
        .claimNFTs(web3Id, startIndex, endIndex)
        .send({ from: account })
        .once('transactionHash', () => {})
        .once('receipt', (receipt) => {
          res(receipt);
        })
        .on('error', (err) => {
          rej(err);
        });
    });
  });

export const withdrawNftsReq = async (account, poolId) =>
  new Promise((res, rej) => {
    useContractReader('HordHpoolManager', undefined, undefined, (contractInstance) => {
      contractInstance.methods
        .withdrawTickets(poolId)
        .send({ from: account })
        .once('transactionHash', () => {})
        .once('receipt', (receipt) => {
          res(receipt);
        })
        .on('error', (err) => {
          rej(err);
        });
    });
  });

export const hpoolWithdrawDepositReq = async (account, poolId) =>
  newContractReader({
    contractName: 'HordHpoolManager',
    functionName: 'withdrawDeposit',
    params: [poolId],
    sendParams: { from: account },
  });

export const hpoolRefundChampionOnFail = (account, poolId) =>
  newContractReader({
    contractName: 'HordHpoolManager',
    functionName: 'withdrawDepositToChampion',
    params: [poolId],
    sendParams: { from: account },
  });

export const hpoolCheckChampionDepositRefund = (poolId) =>
  useContractReader('HordHpoolManager', 'isChampionDepositWithdrawn', [poolId]);

export const getEndIndex = (account, nftWeb3Id) =>
  useContractReader('HordTicketManager', 'getNumberOfStakesForUserAndToken', [account, nftWeb3Id]);

export const getPoolTokenName = (contractAddress) => {
  const promises = [
    useContractReader('HPool', 'name', [], undefined, contractAddress),
    useContractReader('HPool', 'symbol', [], undefined, contractAddress),
  ];
  return Promise.allSettled(promises);
};

export const getHpoolAssetsInfo = async (hpoolAddress) =>
  useContractReader('HPool', 'hPool', [], undefined, hpoolAddress);

export const getTransferAndTradingFees = async (hpoolAddress) =>
  useContractReader('MatchingMarket', 'hPoolToChampionFee', [hpoolAddress]);

export const claimChampSuccessFee = async (amount = 0, hpoolAddress, account) =>
  new Promise((res, rej) =>
    useContractReader(
      'HPool',
      undefined,
      undefined,
      (contractInstance) => {
        contractInstance.methods
          .withdrawChampionFee(amount)
          .send({ from: account })
          .once('transactionHash', () => {})
          .once('receipt', (receipt) => {
            console.log('depositHPool_receipt', receipt);
            res(receipt);
          })
          .on('error', (err) => {
            console.log('depositHPool_receipt_error', err);
            rej(err);
          });
      },
      hpoolAddress,
    ),
  );

export const claimTransferAndTradingFees = async (hpoolAddress, web3PoolId, account) =>
  new Promise((res, rej) =>
    useContractReader('MatchingMarket', undefined, undefined, (contractInstance) => {
      contractInstance.methods
        .withdrawChampionTradingAndTransferFee(hpoolAddress, web3PoolId)
        .send({ from: account })
        .once('transactionHash', () => {})
        .once('receipt', (receipt) => {
          console.log('depositHPool_receipt', receipt);
          res(receipt);
        })
        .on('error', (err) => {
          console.log('depositHPool_receipt_error', err);
          rej(err);
        });
    }),
  );

export const parseParamsInput = (signature = '') => signature.substring(10, signature.length);
export const parseMathodInput = (signature = '') => signature.substring(0, 10);

export const parseInputsByAbi = async (Abi = [], input) => {
  const { abi } = await window._web3.eth;
  const values = await abi.decodeLog(Abi, input);
  return values;
};

export const parseInputs = async (Abi, input) => {
  try {
    const paramsInput = parseParamsInput(input);
    const values = await parseInputsByAbi(Abi, paramsInput);
    return values;
  } catch (error) {
    console.log({ __: error });
  }
};

export const getMethodSignatures = async (methodAbi) => {
  try {
    const { abi } = await window._web3.eth;
    const values = await abi.encodeFunctionSignature(methodAbi);
    return values;
  } catch (error) {
    console.log({ __: error });
  }
};

export const compareMethodsSignatures = async (methodAbi, input) => {
  const methodInput = parseMathodInput(input);
  const methodSignature = await getMethodSignatures(methodAbi);
  return methodInput === methodSignature;
};

export const getPoolsUserSubscribedFor = (walletAddress) =>
  useContractReader('HordHpoolManager', 'getPoolsUserSubscribedFor', [walletAddress]);

export const getuserTokensBalances = (userwallet, tokens = []) =>
  useContractReader('DecentraLabTokensUtil', 'tokenBalancesForUser', [userwallet, tokens], undefined);

export const hpoolGetUserSubscriptionForPool = async (poolId, account) => {
  const subscriptionInfo = await newContractReader({
    contractName: 'HordHpoolManager',
    functionName: 'getUserSubscriptionForPool',
    params: [poolId, account],
  });
  return subscriptionInfo;
};
